import React from "react";
import { useLocation } from "react-router-dom";
import Map2DView from "./Map2d.jsx";
import ThreeDView from "./Map3D.jsx";

/**
 * MapLibreView
 *
 * Pure routing shell — decides which view to render based on the current
 * pathname. All state, refs, and logic live inside the child components.
 */
const MapLibreView = () => {
  const location = useLocation();
  const is3DView =
    location.pathname === "/3d-view" ||
    location.pathname.endsWith("/3d");

  return (
    <div style={{ position: "relative", height: "100vh", width: "100vw" }}>
      {is3DView ? <ThreeDView /> : <Map2DView />}
    </div>
  );
};

export default MapLibreView;